module.exports = __webpack_public_path__ + "img/7.69001d66.png";